import { useSeo } from "@/lib/seo";
import { LOCATIONS, REGION_GROUPS } from "@/data/locations";
import { PageHeader } from "@/components/site/PageHeader";
import { LocationCard } from "@/components/site/LocationCard";
import { ContextualCTA } from "@/components/site/ContextualCTA";

export default function Locations() {
  useSeo({
    title: "Locations",
    description:
      "Location intelligence for Uttarakhand property — Dehradun, Mussoorie, Rishikesh, Haridwar, Nainital, Mukteshwar, Almora and Ranikhet, across Garhwal and Kumaon.",
    path: "/locations",
  });

  return (
    <>
      <PageHeader
        eyebrow="Locations"
        marker="SS·LOC"
        title="Place-by-place intelligence"
        intro="Each location in Uttarakhand carries a different terrain, access profile, regulatory context and risk. These are considered readings — not listings."
        breadcrumbs={[{ label: "Locations" }]}
      />

      {REGION_GROUPS.map((group) => {
        const locs = group.slugs.map((s) => LOCATIONS.find((l) => l.slug === s)).filter(Boolean);
        return (
          <section key={group.key} className="ss-container pb-16" data-testid={`region-${group.key}`}>
            <div className="flex items-center gap-4 mb-8 border-t border-[#E2DDD5] pt-6">
              <h2 className="font-display text-2xl sm:text-3xl font-light text-[#1A1C1E]">{group.label}</h2>
              <span className="font-mono-ss text-[0.66rem] tracking-widest text-[#8A9098]">{locs.length} locations</span>
            </div>
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-7">
              {locs.map((l, i) => <LocationCard key={l.slug} location={l} index={i} />)}
            </div>
          </section>
        );
      })}

      <ContextualCTA
        title="Weighing a specific location?"
        text="We can help you understand what a place is really like to buy into — beyond the view."
        whatsappMessage="Hi Suhail, I'm comparing a few locations in Uttarakhand and would like your perspective."
      />
    </>
  );
}
